webpackJsonp([162898551421021],{

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.a073c1f6.png";

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(19);
	
	__webpack_require__(919);
	
	var _logo = __webpack_require__(291);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotFoundPage = function NotFoundPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'notfound-page' },
	    _react2.default.createElement(
	      _semanticUiReact.Container,
	      { textAlign: 'center' },
	      _react2.default.createElement(_semanticUiReact.Image, { centered: true, src: _logo2.default }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        '404: Page Not Found'
	      )
	    )
	  );
	};
	
	exports.default = NotFoundPage;
	module.exports = exports['default'];

/***/ }),

/***/ 919:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-404-js-40e841cf72091da7f162.js